export const SITE_CONFIG = {
  name: 'EiFO Academy',
  tagline: 'Education is Future Opportunity — modern, interactive learning that keeps kids curious.',
  address: '701 Main St. No. 401 Freeland, PA 18224',
  phones: [
    { label: 'EN', number: '+1-570-578-0343' },
    { label: 'CN/EN', number: '+1-272-315-7512' },
  ],
  email: 'support@eifo.us',
  social: {
    facebook: 'https://www.facebook.com/eifous/',
    // YouTube link parked — re-wire into the footer + homepage `sameAs` once the
    // channel has content of note. URL kept here so re-adding is a one-line change.
    youtube: 'https://www.youtube.com/@eifolanguagecenter7962',
  },
  copyright: '© 2026 EiFO Academy LLC. All Rights Reserved.',
  url: 'https://eifo.us',
} as const;

// `labelKey` resolves against the `public.nav` i18n namespace at the render
// site (e.g. t('public.nav.home')). Kept as keys (not literals) so the public
// header/footer/mobile-nav stay translatable.
export const NAV_LINKS = [
  { href: '/', labelKey: 'public.nav.home' },
  { href: '/courses', labelKey: 'public.nav.courses' },
  { href: '/educators', labelKey: 'public.nav.team' },
  { href: '/blog', labelKey: 'public.nav.blog' },
  { href: '/about', labelKey: 'public.nav.about' },
  { href: '/contact', labelKey: 'public.nav.contact' },
] as const;
